import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { actions as rankingActions } from 'features/ranking';
import { rankTypes } from '../data';
import { getCurrentAgentTournamentMonthState, getPreviousAgentTournamentMonth } from './tournamentDates';

export default function useRanking() {
  const [monthState, setMonthState] = useState(getCurrentAgentTournamentMonthState);
  const { myRank: sessionRank } = useSelector(state => state.rankings);

  const history = useHistory();
  const dispatch = useDispatch();
  const { actionProcessing, myRank, agentsRanking, withRanking, rubyPlayRanking } = useSelector(
    state => state.rankings,
  );

  useEffect(() => {
    if (!withRanking) {
      history.push('/');
    } else {
      dispatch(rankingActions.getAgentsRanking(monthState.value));
      if (sessionRank?.rank === rankTypes.providerSilver)
        dispatch(rankingActions.getRubyPlayAgentsRanking(monthState.value));
    }
  }, [dispatch, history, monthState.value, sessionRank?.rank, withRanking]);

  const toggleMonth = useCallback(() => {
    const currentMonthState = getCurrentAgentTournamentMonthState();
    const previousMonth = getPreviousAgentTournamentMonth(currentMonthState.value);

    setMonthState(() => {
      if (monthState.month === 'current') {
        return {
          value: previousMonth,
          month: 'previous',
        };
      } else {
        return currentMonthState;
      }
    });
  }, [monthState.month]);

  return {
    actionProcessing,
    agentsRanking,
    rubyPlayRanking,
    myRank,
    toggleMonth,
    month: monthState.month,
  };
}
